module.exports = __webpack_public_path__ + "img/hand-pen.a033944b.svg";